export const environment = {
  production: false,
  backendHost: "https://bdapi.paybyself.com/",
  domain: "https://paybyself.com/",
  documentURL: "https://api.paybyself.com/",
  project: "paybyself",
  serverType: "prod", //dev_bangladesh OR sandbox_bangladesh OR prod_bangladesh
};
